import { ContainerElement, DreamBlock } from '@typedream/core';
import { TRenderElementProps } from '@udecode/plate-core';
import { ComponentType } from 'react';
import { createTPluginFactory } from '../../plate';
import { ELEMENT_CONTAINER, KEY_SYNCED_CONTAINER } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';
import { ContainerElementEditor } from './components/ContainerElement';

export const createSyncedContainerPlugin = createTPluginFactory({
  key: KEY_SYNCED_CONTAINER,
  component: withDropTarget(
    ContainerElementEditor as ComponentType<TRenderElementProps>,
  ),
  isElement: true,
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: (element: DreamBlock) => {
      const directions: Array<'s' | 'w' | 'e'> = ['w', 'e'];
      if ((element as ContainerElement).height) {
        directions.push('s');
      }
      return { directions };
    },
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/syncedcontainer.png',
      title: 'Synced Container',
      subtitle: 'Sync content across pages',
      keywords: ['sync', 'container', 'section', 'box', 'card', 'block'],
    },
    format: {
      formatType: 'block',
      blurAfterSet: true,
      insertNode: {
        type: ELEMENT_CONTAINER,
        background: 'default',
        align: 'align_center',
        transclusion_enabled: true,
        children: [
          {
            text: '',
          },
        ],
      } as DreamBlock,
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: [
        'height',
        'width',
        'width_max',
        'align',
        'vertical_align',
        'style',
        'background',
        'backgroundImage',
        'backgroundDarken',
        'backgroundVideo',
        'keep_aspect_ratio',
        'mobile_hide',
        'desktop_hide',
        'url',
        'internal_link',
        'page_id',
        'open_in_new_tab',
        'animation',
        // properties for synced container
        'transclusion_enabled',
        'transclusion_reference_id',
        'transclusion_updated_at',
        'name',
      ],
    },
  },
});
